
<template>

    <div class="group q-mb-md">
        <div class="text-h6 q-mb-sm">Задержка отправки заявки</div>
        <div class="row q-col-gutter-md row items-start delay">

            <q-input v-for="(delayType, delayIndex) in [{days: 'Дней'}, {hours: 'Часов'}, {minutes: 'Минут'}]"
                     :label="Object.values(delayType)[0]"
                     :model-value="delayFilterValue(service.value, Object.keys(delayType)[0])"
                     @update:model-value="
                        newValue => {
                            const newValueLimited = setTimeValue(newValue, Object.keys(delayType)[0]);
                            setDelayFilterValue(service.value, Object.keys(delayType)[0], newValueLimited);
                        }
                     "
                     type="number"
                     min="0"
                     :max="timeLimit[Object.keys(delayType)[0]]"
                     filled
                     class="col"
            />
        </div>
    </div>

    <div class="row">
        <div v-for="(filter, filterIndex) in settings.services[service.value].filters" class="group q-mb-md"
             :class="[
             (filter.type === 'range' ? 'col-12' : 'col-4')
         ]"
        >
            <div class="text-h6">{{filter.label ?? filterIndex}}</div>
            <div class="text" v-if="filter.description">{{filter.description}}</div>

            <div v-if="filter.type === 'range'" class="row q-col-gutter-md">
                <q-input v-for="(rangeFilter, rangeFilterIndex) in filter.value" :key="rangeFilterIndex" class="col"
                         :model-value="getFilterValue(service.value, filterIndex, rangeFilterIndex)"
                         @update:model-value="newValue => setFilterValue(service.value, filterIndex, newValue, rangeFilterIndex)"
                         :label="(filter.valueLabels && filter.valueLabels[rangeFilterIndex] ? filter.valueLabels[rangeFilterIndex] : rangeFilterIndex)"
                         type="number"
                         min="0"
                         filled
                />
            </div>
            <div v-else-if="filter.type === 'checkbox'" class="q-gutter-md">
                <q-checkbox
                    :model-value="getFilterValue(service.value, filterIndex)"
                    @update:model-value="newValue => setFilterValue(service.value, filterIndex, newValue)"
                    toggle-indeterminate
                    :label="filter.label ?? filterIndex"
                />
            </div>
        </div>
    </div>

</template>

<script setup>
import {ensureNestedPath} from "@/assets/js/functions";
import { defineEmits, reactive, toRefs } from 'vue';

const {settings, service, siteId} = defineProps(['settings', 'service', 'siteId'])
const emit = defineEmits(['submit'])

const timeLimit = {
    days: 19,
    hours: 23,
    minutes: 59
}

const setTimeValue = (value, key) => {
    value = parseInt(value)
    if (value < 0) return 0
    if (value > timeLimit[key]) return timeLimit[key]
    return value
}

function delayFilterValue(service, delayType) {
    if(siteId){
        ensureNestedPath(settings.services, `${service}.override.value.${siteId}.delay.${delayType}`)
        return settings.services[service].override.value[siteId].delay[delayType]
    }else{
        return settings.services[service].delay[delayType]
    }
}

const setDelayFilterValue = (service, delayType, newValue) => {
    if(newValue) newValue = parseInt(newValue)
    if(siteId){
        ensureNestedPath(settings.services, `${service}.override.value.${siteId}.delay.${delayType}`)
        settings.services[service].override.value[siteId].delay = reactive({
            ...settings.services[service].override.value[siteId].delay,
            [delayType]: newValue
        })
    }else{
        settings.services[service].delay[delayType] = newValue
    }

    emit('submit', settings)
}




function getFilterValue(service, filterIndex, rangeFilterIndex = null) {

    if (siteId) {
        if (rangeFilterIndex) {
            ensureNestedPath(settings.services, `${service}.override.value.${siteId}.filters.${filterIndex}.${rangeFilterIndex}`)
            return settings.services[service].override.value[siteId].filters[filterIndex][rangeFilterIndex];
        } else {
            ensureNestedPath(settings.services, `${service}.override.value.${siteId}.filters.${filterIndex}`)
            return settings.services[service].override.value[siteId].filters[filterIndex];
        }
    }

    return (rangeFilterIndex
        ? settings.services[service].filters[filterIndex].value[rangeFilterIndex]
        : settings.services[service].filters[filterIndex].value
    )
}

function setFilterValue(service, filterIndex, newValue, rangeFilterIndex = null) {

    if(siteId){
        if (rangeFilterIndex) {
            ensureNestedPath(settings.services, `${service}.override.value.${siteId}.filters.${filterIndex}`)
            settings.services[service].override.value[siteId].filters[filterIndex][rangeFilterIndex] = newValue;
        } else {
            ensureNestedPath(settings.services, `${service}.override.value.${siteId}.filters`)
            settings.services[service].override.value[siteId].filters[filterIndex] = newValue;
        }
    }else{
        if(rangeFilterIndex){
            settings.services[service].filters[filterIndex].value[rangeFilterIndex] = newValue
        }else{
            settings.services[service].filters[filterIndex].value = newValue
        }
    }

    emit('submit', settings)
}
</script>